// extracted by mini-css-extract-plugin
module.exports = {"inputsGroup":"UserModal_inputsGroup__1DW-H","divider":"UserModal_divider__72W-T"};